import {ERecommendationsTypes, IRecommendationsResponse} from '../IRecommendationsMgr';
import RecommendationsProvider from './RecommendationsProvider';
import {RecommendationTypes} from 'coreStore/data/products/types';
import ProductModel from 'coreClasses/product/ProductModel';
import ManagerRepository from 'coreClasses/ManagerRepository';

/**
 * Represents SFCCRecommendationProvider
 */
class SFCCRecommendationProvider extends RecommendationsProvider {
	private typesMapping = {
		[ERecommendationsTypes.COMPLETE_THE_SET]: RecommendationTypes.STYLE_IT_WITH,
		[ERecommendationsTypes.YOU_MAY_ALSO_LIKE]: RecommendationTypes.RECOMMENDATION,
		[ERecommendationsTypes.SHOP_THE_LOOK]: RecommendationTypes.PDP_SHOP_THE_LOOK,
		[ERecommendationsTypes.OTHER]: RecommendationTypes.OTHER,
	};

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 */
	constructor(managerRepository: ManagerRepository) {
		super(managerRepository, 'SFCC');
	}

	/**
	 * Returns recommendations
	 * @param {ERecommendationsTypes} type - recommendation type
	 * @param {ProductModel[]} products - product model
	 * @return {IRecommendationsResponse} - recommendations
	 */
	getRecommendations(type: ERecommendationsTypes, products: ProductModel[]): Promise<IRecommendationsResponse> {
		const recommendations = products[0].getRecommendations(this.typesMapping[type]);

		return Promise.resolve({
			productIds: recommendations.map((product) => product.recommendedItemId),
			recommenderName: type
		} as IRecommendationsResponse);
	}
}

export default SFCCRecommendationProvider;
